export default {
    screening: '/screening/report',
};
